export const usePageScrollLockState = (elementName: string) => {
  const scrollLockStore = useMyScrollLockStore();

  const activatePageScrollLock = () => {
    scrollLockStore.addPageScrollLockForElement(elementName);
  };

  const deactivatePageScrollLock = () => {
    scrollLockStore.removePageScrollLockForElement(elementName);
  };

  onUnmounted(() => {
    scrollLockStore.removePageScrollLockForElement(elementName);
  });

  return {
    activatePageScrollLock,
    deactivatePageScrollLock,
  };
};
